import React, { useState, useRef, useEffect } from 'react';
// import './Slider.css'; // Import your custom CSS for styling
import { RUPEE_SYMBOL } from '../Strings';

const Slider = ({ min, max, step, onChange, sliderData, mostSelected, selectedIndex,zeroTDS }) => {
  const [value, setValue] = useState(selectedIndex);
  const sliderRef = useRef(null);
  const [ticks, setTicks] = useState([]);
  const isDragging = useRef(false);

  useEffect(() => {
    const ticks = [];
    for (let i = min; i <= max; i += step) {
      ticks.push(i);
    }
    setTicks(ticks);
  }, [sliderData, min, max, step]);
  useEffect(() => {
    if (sessionStorage.getItem("channel") === "OEMAPS1") {
      //   import('./TransactionSummaryOEM.css');
      console.log("came into OEMAPS1")
      import('./SliderOEM.css');
    } else {
      console.log("came into APS")
      import('./Slider.css');
    }
  }, [])

  const updateValue = (offsetX) => {
    const totalWidth = sliderRef.current.offsetWidth;
    let newValue = (offsetX / totalWidth) * (max - min) + min;

    // Boundary checks
    if (newValue < min) {
      newValue = min;
    } else if (newValue > max) {
      newValue = max;
    }

    const roundedValue = Math.round(newValue / step) * step;
    setValue(roundedValue);
    if (onChange) {
      onChange(sliderData[roundedValue]);
    }
  };

  const handleMouseDown = (e) => {
    isDragging.current = true;
    const rect = sliderRef.current.getBoundingClientRect();
    const offsetX = e.clientX - rect.left;
    updateValue(offsetX);
  };

  const handleMouseMove = (e) => {
    if (isDragging.current) {
      const rect = sliderRef.current.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      updateValue(offsetX);
    }
  };

  const handleMouseUp = () => {
    isDragging.current = false;
  };

  const handleTouchStart = (e) => {
    isDragging.current = true;
    const rect = sliderRef.current.getBoundingClientRect();
    const offsetX = e.touches[0].clientX - rect.left;
    updateValue(offsetX);
  };

  const handleTouchMove = (e) => {
    if (isDragging.current) {
      const rect = sliderRef.current.getBoundingClientRect();
      const offsetX = e.touches[0].clientX - rect.left;
      updateValue(offsetX);
    }
  };

  const handleTouchEnd = () => {
    isDragging.current = false;
  };

  return (
    <div
      id="slider"
      className="slider1"
      ref={sliderRef}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div
        className="slider1-fill"
        style={{
          position: 'absolute',
          width: `${((value - min) / (max - min)) * 100}%`,
        }}
      />
      <div
        className="slider1-thumb"
        style={{
          position: 'absolute',
          left: `${((value - min) / (max - min)) * 100}%`,
          transform: 'translateX(-50%)',
          // pointerEvents: 'none',
        }}
      />

      {ticks.map((tick, index) => (
        <div
          key={index}
          className="slider-dot"
          style={{
            width: '6px',
            height: '6px',
            borderRadius: '50%',
            position: 'absolute',
            left: `${((tick - min) / (max - min)) * 100}%`,
            transform: 'translateX(-50%)',
            top: '-2.5px',
            display: `${mostSelected === sliderData[index] ? 'flex' : 'none'}`,
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              marginTop: '8px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <div className="arrow-up"></div>
            <span
             className='mostSelectedDiv'
              style={{
                whiteSpace: 'nowrap',
                fontSize: '0.7rem',
                fontWeight: '700',
                borderRadius: '4px',
                padding: '4px 8px',
              }}
            >
              most selected
            </span>
          </div>
        </div>
      ))}


{ticks.map((tick, index) => (
        <div
          key={index}
          className="slider-dot"
          style={{
            width: '6px',
            height: '6px',
            borderRadius: '50%',
            position: 'absolute',
            left: `${((tick - min) / (max - min)) * 100}%`,
            transform: 'translateX(-50%)',
            top: '-2.5px',
            display: `${zeroTDS === sliderData[index] ? 'flex' : 'none'}`,
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              marginTop: '8px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <div className="arrow-up1"></div>
            <span
             className='zeroTds'
              style={{
                whiteSpace: 'nowrap',
                fontSize: '0.7rem',
                fontWeight: '700',
                borderRadius: '4px',
                padding: '4px 8px',
              }}
            >
             Zero TDS
            </span>
          </div>
        </div>
      ))}

      {/* Ticks / Markers */}
      <div className="slider1-ticks">
        {ticks.map((tick, index) => (
          <div
            key={index}
            className="slider1-tick"
            style={{
              position: 'absolute',
              left: `${((tick - min) / (max - min)) * 100}%`,
              transform: 'translateX(-50%)',
              top: '-5px',
              width: '1px',
            }}
          >
            <span
              className={(value === index ? 'trackerSelect'  : "")}
              style={{
                display: 'flex',
                flexDirection: 'column',
                ...(index === 0
                  ? { alignItems: 'flex-start' }
                  : index === ticks.length - 1
                  ? { alignItems: 'flex-end' }
                  : { alignItems: 'center' }),
                fontSize: '0.8rem',
              }}
            >
              <div>
                {RUPEE_SYMBOL}
                {sliderData[index]}
              </div>
              <span
                style={{
                  width: '1px',
                  height: '8px',
                  background: '#bababa',
                  marginTop: '4px',
                }}
              />
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Slider;
